/**
 * @generated SignedSource<<c0a1c7e31e685848038cd0d4c56bf5bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "payableId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paymentMethod"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "amount",
        "variableName": "amount"
      },
      {
        "kind": "Variable",
        "name": "payableId",
        "variableName": "payableId"
      },
      {
        "kind": "Variable",
        "name": "paymentMethod",
        "variableName": "paymentMethod"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "InitPaymentSessionOutput",
    "kind": "LinkedField",
    "name": "InitPaymentSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionData",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reference",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdyenPaymentFormInitSessionMutation",
    "selections": (v4/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdyenPaymentFormInitSessionMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "c657750d797ae2643f06d00ceb076022",
    "id": null,
    "metadata": {},
    "name": "AdyenPaymentFormInitSessionMutation",
    "operationKind": "mutation",
    "text": "mutation AdyenPaymentFormInitSessionMutation(\n  $type: PayableType!\n  $paymentMethod: PaymentMethod!\n  $payableId: Int\n  $amount: Float\n) {\n  InitPaymentSession(type: $type, paymentMethod: $paymentMethod, payableId: $payableId, amount: $amount) {\n    id\n    sessionData\n    reference\n  }\n}\n"
  }
};
})();

node.hash = "81210ab9eb5d13b1edff69111ba8e902";

module.exports = node;
